export default {
  app: {
    title: "Test 123",
  },
  refresh: {
    title: "Are you active?",
    cta: "You were registered as not active, please confirm that you are active in the next minute, if you don't you will be logged out.",
  },
  common: {
    language: "Language",
    english: "English",
    serbian: "Serbian",
    close: "Close",
    dataGridExample: "Data Grid Example",
    trademark: "TM",
    search: "Search",
    error: "Error",
    continue: "Continue",
    labelUsername: "Username",
    labelEmail: "Email",
    labelPassword: "Password",
    next: "Next",
    nextPage: "Next page",
    previousPage: "Previous page",
    back: "Back",
    goBack: "Go Back",
    ok: "Ok",
    done: "Done",
    confirm: "Confirm",
    printDownload: "Print/Download",
    cancel: "Cancel",
    remove: "Remove",
    invite: "Invite",
    save: "Save",
    complete: "Complete",
    download: "Download",
    yes: "Yes",
    no: "No",
    to: "to",
    select: "Select...",
    none: "None",
    date: {
      range: "{{start}} to {{end}}",
    },
    apply: "Apply",
    contactUs: "Contact us",
    tryForFree: "Free Trial",
    supportLink: "im.support@tremium.net",
    martketingLink: "marketing@tremium.net",
    phoneNumber: "+38160 366 02 71",
  },
  pageTitles: {
    Home: "Home Page | Tremium Software",
    About: "About Us | Tremium Software",
    Career: "Career Page | Tremium Software",
  },
  pages: {
    home: "Home",
    login: "Login",
    register: "Register",
    forgotPassword: "Forgot password",
    error: "Error",
    notFound: "Not Found",
    profile: "Profile",
    settings: "Settings",
    dashboard: "Dashboard",
    about: "About",
    careers: "Careers",
    contact: "Contact",
  },
  register: {
    registerTitle: "Register",
    usernameRequired: "Username is required.",
    emailFormat: "Invalid email address format.",
    emailRequired: "An email or username is required.",
    passwordLength: "Your password contain between 8 and 50 characters.",
    passwordRequired: "A Password is required.",
  },
  login: {
    welcome: "React template",
    dontHaveAccount: "Don't have an account? ",
    emailFormat: "Invalid email address format.",
    emailRequired: "An email or username is required.",
    noUsers: "There are no users with that email.",
    passwordStrength: "Your password is {{strength}}.",
    passwordLength: "Your password contain between 8 and 50 characters.",
    signUpRecommendation: "Sign up",
    email: "Please enter your email address or username to log in:",
    logInTitle: "Log In",
    logIn: "Log In",
    signUp: "Sign Up",
    usernameRequired: "Username is required.",
    passwordRequired: "A Password is required.",
    forgotYourPassword: "Forgot your password?",
    forgotPasswordEmail: "Email",
    useDifferentEmail: "Use different email address or username",
  },
  password: {
    weak: "weak",
    average: "average",
    good: "good",
    strong: "strong",
  },
  forgotPassword: {
    title: "Forgot Password",
    label: "Send email",
    emailRequired: "An email is required.",
    emailFormat: "Invalid email address format.",
    forgotPassword: {
      title: "Forgot Password",
      subtitle:
        "Please answer the security question to gain access to your account:",
      label: "Reset Password",
    },
  },
  notFound: {
    text: "We're sorry but we couldn't find the page you were looking for.",
    goBack: "Go back to homepage",
  },
  errorPage: {
    text: "We're sorry, an internal server error came up. Please be patient or try again later.",
    goBack: "Go back to homepage",
    logout: "Logout",
  },
  apiErrors: {
    ClientIpAddressIsNullOrEmpty: "Client Ip address is null or empty",
    UsernameDoesNotExist: "Username does not exist",
    WrongCredentials: "Wrong credentials",
    SomethingWentWrong: "Something went wrong",
    WrongPasswordAccountIsLocked: "Wrong credentials, account is locked",
    AccountIsLocked: "Account is locked",
  },
  footer: {
    text: "Inspect Master <3> Copyright © 2023 </3> <1></1> <2>Tremium Software.</2> All rights reserved.",
    navItems: {
      item1: "Home",
      item2: "Benefits",
      item3: "Demo",
      item4: "Help",
      item5: "Privacy policy",
      item6: "Contact",
    },
  },
  header: {
    navItems: {
      item1: "Home",
      item2: "Benefits",
      item3: "Help",
      item4: "Contact",
      item5: "Sign In"
    },
  },
  sectionHero: {
    title: "Process Verification. Control Automation. Time Savings.",
    text: "Inspect Master is your go-to solution for workplace safety inspections. Through automation, standardization, and structured data management, our platform resolves critical challenges in traditional safety inspection workflows.",
    buttonLabel: "Contact Us",
  },

  sectionWhy: {
    title: "Why Inspect Master?",
    cards: {
      card1: {
        title: "Automation",
        text: "The inspection process is automated from the very beginning of the inspection to the creation of the expert report as the final product. Automating the process saves time and provides efficiency in operations.",
      },
      card2: {
        title: "Adaptability",
        text: "Using personalized templates, our platform enables the customization of the inspection process for any type of examination.",
      },
      card3: {
        title: "Error-Free",
        text: "By preparing templates that guide precisely through the inspection process, the likelihood of errors is reduced, and efficiency in operations is increased.",
      },
      card4: {
        title: "Time Savings",
        text: "Forget about time-consuming procedures and lengthy report creation. Inspect Master automatically generates expert reports, saving time on data entry and processing.",
      },
      card5: {
        title: "Administration and Structure",
        text: "Our application offers easy management of all parameters needed for creating findings. The expert report is the main document of the application, and the system allows for searching and filtering data according to needs.",
      },
    },
  },
  sectionInfo: {
    text: "Manual data entry and lack of documentation become a thing of the past with our software solution. Inspect Master enables quick and efficient data entry via computer, phone, and tablet, simplifying fieldwork. <br/> In order to accelerate and standardize the inspection process, our application generates an expert report created according to pre-made templates and in compliance with current regulations.",
  },
  sectionMakePossible: {
    title: "What Does <br /> Inspect Master Provide?",
    items: [
      "Ability to Enter Inspection Results Using Various Formats, Including Text, Images, and Tables",
      "Creation of Expert Reports After Inspection Data Input",
      "Seamlessly Export Expert Reports in a PDF Format",
      "Automatic Sending of Expert Reports via Email",
      "Ability to Copy Existing Reports",
      "Use Tablets and Smartphones for Quick and Efficient Data Entry",
      "Archiving Expert Reports and Storing Backups in the Cloud",
      "Ability to Create Templates for Automating the Inspection of Processes and Equipment According to Industry-Specific Requirements and Standards",
      "Search and Quick Access to All Expert Reports",
    ],
  },
  sectionTrial: {
    title: "Sign up for the first <br /> month free!",
    text1: "The Free Version Includes:",
    text2:
      "After the One-Month Period, Please Contact Us for Pricing Options and License Renewal.",
    trialList: [
      "Unlimited Users and Expert Reports",
      "Instant Report Delivery via Email Upon Closure",
      "Customizable Printing Options and Access to Templates",
      "Ability to Duplicate Templates and Findings",
      "Cloud Storage for Reports at the Time of Closure",
      "Document Management Features",
    ],
  },
  sectionFAQ: {
    title: "Frequently Asked Questions",
    note: "Still have questions?",
    questions: {
      question1: {
        question: "How to Register?",
        answer:
          "With just one call or email! The Inspect Master support team will set up the first account for your team, granting you administrator privileges. After that, the administrator can add other team members and assign them different roles within the platform.",
      },
      question2: {
        question: "What Are the Key Components of Inspect Master?",
        answer:
          "Scanning subjects, composed of multiple sections, form a core part of the application. These are created prior to the inspection to streamline subsequent evaluations. In addition to scanning subjects, expert reports are the final documents produced after inspections, generated by entering the results gathered during the process.",
      },
      question3: {
        question: "How Are the Inspection <i>parameters</i> predefined?",
        answer:
          "Within the platform, essential parameters need to be defined: the company's areas of operation  - finding types, the regulations and standards applicable to inspections, the instruments used for conducting inspections, and the clients for whom the inspections are performed.",
      },
      question4: {
        question: "How Are Scanning <i>subjects</i> predefined?",
        answer:
          "Scanning Subjects can be predefined in two ways: by importing from a shared library or by creating them independently. When creating reports independently, it's important to define the finding type, the instruments used for inspection, and the regulations and standards applicable to the inspection. After that, questions to be answered during the inspection are prepared. Additionally, conclusions and possible answers to the questions can be predefined to optimize data entry time in the field.",
      },
      question5: {
        question: "How Are Inspection Results Entered?",
        answer:
          "Answers to the predefined questions  are entered as text, in table format, as images, or by selecting from available options. Finally, a conclusion is formed—either positive or negative. A single expert report can encompass multiple scanning subjects.",
      },
      question6: {
        question: "What Are the Additional Features?",
        answer:
          "In addition to core functionalities, Inspect Master offers automatic saving of expert reports. Reports can be stored in the cloud or sent directly to clients via email. Another key advantage is the use of predefined, template-based answers to frequently asked questions, which can be automatically added to expert reports, as well as pre-designed inspection templates.",
      },
    },
  },
  sectionAbout: {
    title: "About Us",
    text: "<1>A few years ago, a long-term partner approached us with a challenge they faced in their daily operations. They needed a tool to help optimize processes, conduct inspections more efficiently, and generate expert reports. Thus, Inspect Master was born—a solution we designed to address everyday challenges and real business issues in the field of workplace safety compliance. </1> Inspect Master is a product developed by the IT software company Tremium Software, where our dedicated team works daily to implement the latest changes and functionalities. We strive to remain responsive to our partners' needs while also introducing enough innovations to expand the capabilities of our platform.",
  },
  sectionContact: {
    title: "Contact us",
    text: "Inspect Master provides you with the flexibility to choose the features that best suit your needs. For pricing information or to register for a free trial, please reach out via email at: <1>im.support@tremium.net</1> or by calling us at <2>+38160 366 02 71</2>",
  },
  privacyPolicy: {
    title: "Privacy Policy",
    lastUpdate: "Last Updated: March 11, 2025",
    text: "This Privacy Policy sets forth the terms and conditions under which Inspect Master collects, uses, and processes your personal information when you access or use any of our websites or services. This Privacy Policy describes, among other issues, the types of personal information that we collect, the purposes for which we use it, and any rights and responsibilities you may have concerning such personal information.",
    definition: {
      title: "For the purposes of this Privacy Policy",
      definitions: [
        "<strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.",
        "<strong>Product</strong> (referred to as either „the Produc”, „We”, „Us” or „Our” in this Agreement) refers to Inspect Master.",
        "<strong>Cookies</strong> are small files placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.",
        "<strong>Country</strong> refers to: Serbia, North Macedonia, Montenegro, Switzerland, and EU countries",
        "<strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.",
        "<strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).",
        "<strong>Website</strong> refers to Inspect Master, accessible from <a href='https://www.inspectmaster.net'>www.inspectmaster.net</a>."
      ]
    },
    personalData: {
      title: "Collecting and Using Your Personal Data",
      subtitle: "Types of Data Collected",
      personalDataTitle: "Personal Data",
      personalDataDescription: "While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:",
      personalDataList: [
        "<strong>Email address</strong>",
        "<strong>First name</strong>",
        "<strong>Last name</strong>",
        "<strong>Phone number</strong>",
        "<strong>Company name</strong>",
        "<strong>Tax Identification Number</strong>",
        "<strong>Address</strong>",
        "<strong>Company registration number</strong>",
        "<strong>Title/Position</strong>",
        "<strong>License number</strong>",
        "<strong>Signature image</strong>",
      ],
      usageData: "Usage Data",
      usageDataDescription: [
        "Usage Data is collected automatically when using the Service.",
        "Usage Data may include information such as Your Device's Internet Protocol address (e.g., IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers, and other diagnostic data.",
        "When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.",
        "We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.",
      ],
    },
    cookies: {
      title: "Tracking Technologies and Cookies",
      text: "We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information.",
      browserCookiesSubtitle: "Cookies or Browser Cookies",
      browserCookiesText: "A cookie is a small file placed on Your Device. You can instruct Your browser to refuse all Cookies or to indicate when a Cookie is being sent. However, if You do not accept Cookies, You may not be able to use some parts of our Service. Unless you have adjusted Your browser setting so that it will refuse Cookies, our Service may use Cookies.",
      subtitle: "Types of Cookies we use",
      sessionCookiesTitle: "Necessary / Essential Cookies",
      sessionCookiesList: [
        "<strong>Type:</strong> Session Cookies",
        "<strong>Purpose:</strong> These Cookies are essential to provide You with services available through the Website and to enable You to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that You have asked for cannot be provided, and We only use these Cookies to provide You with those services.",
      ],
      persistentCookiesTitle: "Cookies Policy / Notice Acceptance Cookies",
      persistentCookiesList: [
        "<strong>Type:</strong> Persistent Cookies",
        "<strong>Purpose:</strong> These Cookies identify if users have accepted the use of cookies on the Website.",
      ],
      functionalityCookiesTitle: "Functionality Cookies",
      functionalityCookiesList: [
        "<strong>Type:</strong> Persistent Cookies",
        "<strong>Purpose:</strong> These Cookies allow us to remember choices You make when You use the Website, such as remembering your login details or language preference. The purpose of these Cookies is to provide You with a more personal experience and to avoid You having to re-enter your preferences every time You use the Website.",
      ],
    },
    usePersonalData: {
      title: "Use of Your Personal Data",
      text: "The Company may use Personal Data for the following purposes:",
      list: [
        "<strong>To provide and maintain our Service</strong>, including to monitor the usage of our Service.",
        "<strong>To manage Your Account</strong>: to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user.",
        "<strong>To contact You</strong>: To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.",
        "<strong>To provide You with news</strong>, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information.",
        "<strong>To manage Your requests</strong>: To attend and manage Your requests to Us.",
        "<strong>For other purposes</strong>: We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience.",
      ],
      share: "We may share Your personal information in the following situations:",
      shareList: [
        "<strong>With Your consent</strong> - We may disclose Your personal information for any other purpose with Your consent.",
      ]
    },
    retentionPersonalData: {
      title: "Retention of Your Personal Data",
      list: [
        "The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.",
        "The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period, except when this data is used to strengthen the security or to improve the functionality of Our Service, or we are legally obligated to retain this data for longer periods.",
      ]
    },
    transferPersonalData: {
      title: "Transfer of Your Personal Data",
      list: [
        "Your consent to this Privacy Policy, followed by Your submission of such information, represents Your agreement to that transfer.",
        "The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information.",
        "Our Service may give You the ability to delete certain information about You from within the Service.",
        "You may update or edit Your information at any time by signing in to Your Account, if you have one, and visiting the account settings section that allows you to manage Your personal information. You may also contact Us to request access to, or correct, any personal information that You have provided to Us.",
        "Please note, however, that We may need to retain certain information when we have a legal obligation or lawful basis to do so.",
      ]
    },
    disclosurePersonalData: {
      title: "Disclosure of Your Personal Data",
      textTitle: "Law enforcement",
      text: "Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g., a court or a government agency).",
      otherLegalrequirements: "Law enforcement",
      otherLegalrequirementsText: "The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:",
      otherLegalrequirementsList: [
        "Comply with a legal obligation",
        "Protect and defend the rights or property of the Company",
        "Prevent or investigate possible wrongdoing in connection with the Service",
        "Protect the personal safety of Users of the Service or the public",
        "Protect against legal liability",
      ],
    },
    securityPersonalData: {
      title: "Security of Your Personal Data",
      text: "The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.",
    },
    changesPrivacyPolicy: {
      title: "Changes to this Privacy Policy",
      list: [
        "We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.",
        "We will let You know via email and/or a prominent notice on Our Service, before the change becoming effective and update the „Last updated” date at the top of this Privacy Policy.",
        "You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.",
      ]
    },
    contact: {
      title: "Contact Us",
      text: "If you have any questions about this Privacy Policy, You can contact us:",
    },
  },
};
